import { Typography } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = () => {
  return Object.assign({
    listResultItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, globalStyles);
};

class ListResult extends React.Component {

  render() {

    const { classes, onClick, invalid, iri, pendingDeletion, informationOnly, additionalLabel, listSecondIcon, text, clickableInvalid } = this.props;

    return (
      <ListItem
        data-test={invalid ? "list-item-invalid" : "list-item"}
        className={((invalid || pendingDeletion || informationOnly) && !clickableInvalid) ?
          (informationOnly ?
            classes.infoResult
            :
            classes.invalidResult
          )
          :
          classes.result}>
        <ListItemText className={classes.resultText}
          primary={
            <div className={classes.listResultItem}>
              <div style={{ width: '100%' }}>
                <Typography data-test="result-text" variant="body2">
                  <Tooltip
                    title={iri || text}
                    PopperProps={{
                      "data-test": "result-tip"
                    }}
                  >
                    <span data-test="result-text-words" style={{ wordWrap: 'break-word' }}>{text}</span>
                  </Tooltip>
                </Typography>
                {(additionalLabel || pendingDeletion) &&
                  <div>
                    {additionalLabel && !pendingDeletion && <Typography data-test="additional" variant="caption">{additionalLabel}</Typography>}
                    {pendingDeletion &&
                      <div>
                        <Typography variant="caption">This is pending deletion and will be removed shortly.</Typography>
                        <Typography variant="caption">Once removed the IRI becomes available for reuse.</Typography>
                      </div>}
                  </div>
                }
              </div>
              <div className={classes.resultSecondIcon}>
                {listSecondIcon}
              </div>
            </div>
          }
          onClick={!informationOnly ? onClick : null} />
      </ListItem>
    );
  }
}

ListResult.defaultProps = {
  invalid: false,
  pendingDeletion: null,
  clickableInvalid: false,
  entailed: false,
  informationOnly: false
};

ListResult.propTypes = {
  invalid: PropTypes.bool,
  informationOnly: PropTypes.bool,
  entailed: PropTypes.bool,
  clickableInvalid: PropTypes.bool,
  listSecondIcon: PropTypes.object,
  iri: PropTypes.string,
  pendingDeletion: PropTypes.bool,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  additionalLabel: PropTypes.any,
  classes: PropTypes.object
};

export default withStyles(styles)(ListResult);